import React from "react";

import { Avatar } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { MealPatternNameKind } from "@/gql/graphql";
import MeatIcon from "@assets/icons/beef.png";
import FruitIcon from "@assets/icons/fruits.png";
import DairyIcon from "@assets/icons/milk.png";
import StarchIcon from "@assets/icons/starch.png";
import SugarIcon from "@assets/icons/sugar-cube.png";
import FatIcon from "@assets/icons/trans-fats-free.png";
import VegetableIcon from "@assets/icons/vegetable.png";

interface Props {
  name: MealPatternNameKind;
}

const icons = {
  [MealPatternNameKind.Fat]: FatIcon,
  [MealPatternNameKind.Fruit]: FruitIcon,
  [MealPatternNameKind.MeatHighFat]: MeatIcon,
  [MealPatternNameKind.MeatLowFat]: MeatIcon,
  [MealPatternNameKind.MeatModerateFat]: MeatIcon,
  [MealPatternNameKind.MilkLowFat]: DairyIcon,
  [MealPatternNameKind.MilkNonFatSkim]: DairyIcon,
  [MealPatternNameKind.MilkWhole]: DairyIcon,
  [MealPatternNameKind.RiceHighProtein]: StarchIcon,
  [MealPatternNameKind.RiceLowProtein]: StarchIcon,
  [MealPatternNameKind.RiceMediumProtein]: StarchIcon,
  [MealPatternNameKind.Sugar]: SugarIcon,
  [MealPatternNameKind.Vegetable]: VegetableIcon,
  [MealPatternNameKind.FatsAndOil]: FatIcon,
  [MealPatternNameKind.Fruits]: FruitIcon,
  [MealPatternNameKind.MeatAndSeafood]: MeatIcon,
  [MealPatternNameKind.Dairy]: DairyIcon,
  [MealPatternNameKind.PlantBasedMeat]: MeatIcon,
  [MealPatternNameKind.Starches]: StarchIcon,
  [MealPatternNameKind.Vegetables]: VegetableIcon,
  [MealPatternNameKind.Treats]: SugarIcon,
};

const useStyles = makeStyles()({
  root: {
    width: 40,
    height: 40,
    padding: 8,
  },
});

const MealPatternIcon: React.FC<Props> = ({ name }) => {
  const { classes } = useStyles();

  return <Avatar className={classes.root} alt="" src={icons[name]} />;
};

export default MealPatternIcon;
